import { RocketLaunch } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle } from "./nodeKit";

export default memo(({ data, isConnectable }) => {
  return (
    <NodeCard color="#16a34a" icon={<RocketLaunch />} title="Início do fluxo" width={220}>
      Este bloco marca o início do seu fluxo.
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
